<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-帖子应用-修改
    -->
  <el-dialog
    title="修改帖子应用"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <div class="product-add pb50">
      <el-form
        size="small"
        :model="form"
        ref="form"
        :rules="rules"
        label-width="100px"
      >
        <div class="common-form">修改帖子应用</div>
        <!-- 全分类选择 -->
        <!-- <el-form-item label="选择全分类" prop="name" >
            <div>{{ form.categorya.name }}</div>
        
          <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为帖子应用标题</el-button>
        </el-form-item> -->

        <el-form-item label="帖子名称" prop="name"
          ><el-input
            v-model="form.name"
            placeholder="请输入帖子名称"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <el-form-item label="所属分类" prop="category_id">
  <el-select
    v-model="form.category_id"
    placeholder="请选择分类"
    class="max-w460"
    clearable
  >
    <el-option-group
      v-for="group in categoryList"
      :key="group.category_id"
      :label="group.name"
    >
      <el-option
        :value="group.category_id"
        :label="group.name"
      ></el-option>
      <el-option
        v-for="child in group.child || []"
        :key="child.category_id"
        :value="child.category_id"
        :label="'└─ ' + child.name"
      ></el-option>
    </el-option-group>
  </el-select>
</el-form-item>

        <el-form-item label="发布者" prop="user_id">
          <span>{{ form.user_id }}</span>
        </el-form-item>

        <el-form-item label="是否开通收付费视频标识" prop="is_open_video">
          <el-select
            v-model="form.is_open_video"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="暗" :value="0"></el-option>
            <el-option label="亮" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否推荐" prop="is_recommend">
          <el-select
            v-model="form.is_recommend"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="不推荐" :value="0"></el-option>
            <el-option label="推荐" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否点赞" prop="is_like">
          <el-select
            v-model="form.is_like"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="不点赞" :value="0"></el-option>
            <el-option label="点赞" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否收藏" prop="is_collect">
          <el-select
            v-model="form.is_collect"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="不收藏" :value="0"></el-option>
            <el-option label="收藏" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否免费" prop="is_free">
          <el-select
            v-model="form.is_free"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="免费" :value="0"></el-option>
            <el-option label="不免费" :value="1"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="会员等级" prop="grades">
          <el-select
            v-model="form.grades"
            placeholder="请选择"
            class="max-w460"
          >
            <el-option label="普通用户" :value="0"></el-option>
            <el-option label="v1" :value="1"></el-option>
            <el-option label="v2" :value="2"></el-option>
            <el-option label="v3" :value="3"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="缩略图" prop="model.image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path" />
                    <a
                      href="javascript:void(0);"
                      class="delete-btn"
                      @click.stop="deleteImg(index, 'album')"
                      ><i class="el-icon-close"></i
                    ></a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="name"
          ><el-input
            v-model="form.sort"
            placeholder="请输入排序"
            class="max-w460"
          ></el-input
        ></el-form-item>

        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc"
            >取消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="onSubmit"
            :loading="loading"
            >提交</el-button
          >
        </div>
      </el-form>
      <Upload
        v-if="isProductUpload"
        :config="{ total: 9 }"
        :isupload="isProductUpload"
        @returnImgs="returnProductImgsFunc"
        >上传图片
      </Upload>
      <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
    </div>
  </el-dialog>
</template>

<script>
import Fposts_appApi from "@/api/fposts_app.js";
import Upload from "@/components/file/Upload";
import Categoryas from "@/components/categorya/index.vue";
import draggable from "vuedraggable";
import Uediter from "@/components/UE.vue";
import { sort } from "semver";
export default {
  components: {
    /*图片上传*/
    Upload: Upload,
    Categoryas,
    draggable,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*富文本配置*/
      ueditor: {
        text: "",
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
       categoryList: [],
      /*form表单数据*/
      form: {
        name: "",
        user_id: "",
         category_id: "", // 添加分类ID字段
        is_open_video: 0,
        is_recommend: 0,
        is_like: 0,
        is_collect: 0,
        is_free: 0,
        grades: 0,
        image: [],
        sort: 50
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [
          { required: true, message: "请输入帖子应用名称", trigger: "blur" }
        ]
      },
      dialogVisible: false,
      iscategorya: false,
      excludeIds: [],
      isProductUpload: false,
      code: "album"
    };
  },
  created() {
    console.log(11111);
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getCategory(); // 添加这行
  },
  props: ["open_add", "fposts_app_id"],
  methods: {
    // closeDialogFunc(e) {
    //   console.log(e)
    //   let self = this;
    //   self.iscategorya = false;
    //   if (e.type === 'success') {
    //     let arr = [];
    //     for (let i = 0; i < e.params.length; i++) {
    //       let item = e.params[i];
    //       arr = {
    //         name: item.name,
    //         categorya_id: item.categorya_id,
    //         image: item.image,
    //       };
    //     }
    //     self.form.categorya = arr;

    //   }
    // },
    chooseCategory() {
      this.iscategorya = true;
    },
     getCategory() {
    Fposts_appApi.category_list().then(res => {
      if (res.code === 1) {
        this.categoryList = res.data.list || [];
        // 确保每个一级分类都有child数组
        this.categoryList = this.categoryList.map(item => {
          if (!item.child) {
            item.child = [];
          }
          return item;
        });
      }
    });
  },
    /*上传*/
    openUpload(e) {
      this.isupload = true;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.form.image_id = e[0].file_id;
        this.form.image = e[0].file_path;
        this.isImg = true;
      }
      this.isupload = false;
    },
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    cancelFunc() {
      //取消
      this.dialogFormVisible("error");
    },
    getDetail() {
  let self = this;
  Fposts_appApi.detail({ fposts_app_id: self.fposts_app_id }, true)
    .then(res => {
      self.form = {
        ...res.data,
        category_id: res.data.category_id || "" // 确保分类ID正确赋值
      };
      self.ueditor.text = self.form.intro;
      self.isImg = true;
      self.loading = false;
      if (!self.form.bannar) {
        self.form.bannar = [];
      }
      if (!self.form.image) {
        self.form.image = [];
      }
    })
    .catch(error => {});
},
    onSubmit() {
      let self = this;
      let form = self.form;
      // if(!form.categorya.categorya_id){
      //   self.$message({
      //           message:"请选择全分类",
      //           type: 'error'
      //         });
      //         return;
      // }
      if (form.image.length <= 0) {
        self.$message({
          message: "请上传图片",
          type: "error"
        });
        return;
      }
      form.fposts_app_id = self.fposts_app_id;
      // form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Fposts_appApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: "success"
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消修改，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false, type: "" });
    },
    openProductUpload: function(code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if (this.code == "album") {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          console.log(typeof imgExpt);
          e.forEach(element => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach(e => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }

      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if (code == "album") {
        this.form.image.splice(index, 1);
      } else if (code == "bannar") {
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/fposts_app/index/part/edit.vue